import * as React from "react";
import { cloneElement, useCallback, useState, useRef } from "react";
import ColorPicker from "components/common/ColorPicker";
import Popover from "components/common/Popover";
const ColorPickerPopover = ({
  id,
  placement = "bottom",
  title = "Pick a color",
  triggerNode,
  onChange,
  ...rest
}) => {
  const [show, setShow] = useState(false);
  const toggleTarget = useRef();
  const handleToggle = useCallback(() => {
    setShow(!show);
  }, [show]);
  const onClose = useCallback(() => setShow(false), []);
  const handleChange = useCallback(
    (newColor, event) => {
      onChange(newColor, event, handleToggle);
    },
    [handleToggle, onChange]
  );
  return /* @__PURE__ */ React.createElement(Popover, { id, opened: show, position: placement, onClose }, /* @__PURE__ */ React.createElement(Popover.Target, null, cloneElement(triggerNode, {
    onClick: handleToggle,
    ref: toggleTarget
  })), /* @__PURE__ */ React.createElement(Popover.Dropdown, { title }, /* @__PURE__ */ React.createElement(ColorPicker, { onChange: handleChange, ...rest })));
};
export default ColorPickerPopover;
